export default __webpack_public_path__ + "static/media/logout-gray.1d2fc7b2.svg";